import { CART_TYPE, LineOfProduct, TCart } from '@/services/cart/models/cart';
import { NextRouter } from 'next/router';

export type CartContext = 'CART' | 'SUMMARY';

export function getCartTypeFromLop(lop: LineOfProduct): CART_TYPE {
  if (lop === LineOfProduct.RENT) {
    return CART_TYPE.RENT;
  }

  return CART_TYPE.BUY;
}

type CartItemBaseDetails = {
  name: string;
  cartItemId: number;
  productId: number | string;
  sellingPrice?: number;
  monthlyRentalPrice?: number;
  lop: LineOfProduct;
  quantity: number;
  tenure?: number;
};

export function reduceCartItemsToBasicDetails(cart: TCart) {
  const cartItems: CartItemBaseDetails[] = [];

  if (cart?.buyCart?.buyCartItemsCount as number > 0) {
    cart.buyCart?.buyCartItems?.forEach(item => {
      cartItems.push({
        cartItemId: item.id,
        productId: item.product.id,
        sellingPrice: item.sellingPrice.value,
        lop: item.lineOfProduct,
        name: item.product.name,
        quantity: item.quantity,
      });
    });
  }

  if (cart?.rentCart?.rentalCartItemsCount as number > 0) {
    cart.rentCart?.rentalCartItems?.forEach(item => {
      cartItems.push({
        cartItemId: item.id,
        productId: item.product.id,
        monthlyRentalPrice: item.monthlyRentalPrice.value,
        lop: item.lineOfProduct,
        name: item.product.name,
        quantity: item.quantity,
        tenure: item.tenure,
      });
    });
  }

  return cartItems;
}

export function getCartContext(router: NextRouter): CartContext {
  if (router.pathname.includes('/checkout/summary')) {
    return 'SUMMARY';
  } else {
    return 'CART';
  }
}

export function getCartPageSource(router: NextRouter): 'CHECKOUT_SUMMARY' | 'CART' {
  if (router.pathname.includes('/checkout/summary')) {
    return 'CHECKOUT_SUMMARY';
  } else {
    return 'CART';
  }
}